const state = {
	selectedCategory: ''
}

const getters = {}

const actions = {}

const mutations = {
	setSelectedCategory (state, val) {
		state.selectedCategory = val
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}